import { useEffect, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from '@mui/material/Skeleton';

// Components
import SectionTitle from '../../../SectionTitle';
import OrderCard from '../../../OrderCard';
import Alert from '../../../Alert';

// Queries
import getGlobal from '../../../Queries/getGlobal';

// Styles
import styles from '../index.module.sass';

const STATUS = {
  SE: {
    0: 'Pedido pendiente',
    1: 'Pending order',
  },
  SP: {
    0: 'Pedido pagado',
    1: 'Order paid',
  },
  SA: {
    0: 'Aplicado',
    1: 'Applied',
  },
  SZ: {
    0: 'Inactivo',
    1: 'Inactive order',
  },
};

export default function ReshipmentsTable({
  device,
  setSessionMessage,
  setOrderSelected,
  setBlackList,
}) {
  const { t } = useTranslation('reshipments');
  const [reshipmentsData, setReshipmentsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const language = window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1;

  const getReshipments = useCallback(async () => {
    setLoading(true);
    const data = await getGlobal({
      tmbservice: 'reenvios',
      jsonBody: {
        idioma: language,
      },
    });

    const { message = '', DataDetalleReenvios = [], blackList = false } = data;

    setSessionMessage(message);

    if (data.typeMessage !== 'success') {
      if (message === '498' || message === '499') return false;

      setAlertText(message);
      setOpen(true);
      setLoading(false);
      // Handle other errors
      setLoading(false);
    } else {
      setBlackList(blackList);
      setReshipmentsData(DataDetalleReenvios);
      setLoading(false);
    }

    return [];
  }, [language, setBlackList, setSessionMessage]);

  useEffect(() => {
    getReshipments();
  }, [getReshipments]);

  return (
    <div
      className={`${styles.reshipmentsTable} ${
        device?.screenSize !== 'desktop' ? styles.mobile : ''
      }`}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <SectionTitle title={t('title')} subtitle={t('subtitle')} />
      <div className={styles.container}>
        <OrderCard>
          {loading ? (
            <div>
              <Skeleton variant='rectangular' className={styles.loadingText} />
              <Skeleton variant='rectangular' className={styles.loadingText} />
              <Skeleton variant='rectangular' className={styles.loadingText} />
            </div>
          ) : (
            <div className={`${styles.tableContainer}`}>
              <div className={styles.table}>
                <div className={`${styles.row} ${styles.tableHeader}`}>
                  <div className={styles.cell}>{t('headerOrder')}</div>
                  <div className={styles.cell}>{t('headerAddress')}</div>
                  <div className={styles.cell}>{t('headerStatus')}</div>
                  <div className={styles.cell}>{t('headerActions')}</div>
                </div>

                <div>
                  {reshipmentsData.map((item, index) => {
                    return (
                      <div className={`${styles.row}`} key={index}>
                        <div className={styles.cell}>{item?.Pedido}</div>
                        <div className={styles.cell}>
                          {item.CodigoPostal ? (
                            `${item?.Line1} ${item?.Line2} ${item?.Line3} ${item?.Ciudad}`
                          ) : (
                            <label style={{ color: 'red' }}>{t('noAddress')}</label>
                          )}
                        </div>
                        <div className={styles.cell}>{STATUS[item?.Estatus]?.[language]}</div>
                        <div className={styles.cell}>
                          <label
                            onClick={() => {
                              setOrderSelected(item);
                            }}
                            className={styles.labelDetail}>
                            <i className={`material-icons-outlined ${styles.icon}`}>visibility</i>
                            <label className={styles.textDecoration}>{t('details')}</label>
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </OrderCard>
      </div>
    </div>
  );
}
